import { useMemo } from "react";
import { ITags, ITagsData, IKeyFiguresData, IKeyFigureGroup } from "src/api/server/extended-search";

export const useFilters = (tagsData: ITagsData, keyFiguresData: IKeyFiguresData) => {
    const popularKeyFiguresGroup: IKeyFigureGroup = useMemo(() => {
        return {
            ...keyFiguresData.popularKeyFiguresGroup,
            keyFigures: keyFiguresData.popularKeyFiguresGroup.keyFigures.map(keyFigure => {
                return { ...keyFigure, isPopular: true };
            }),
        };
    }, [keyFiguresData.popularKeyFiguresGroup]);

    const keyFiguresGroupsWithIsPopularIndication: IKeyFigureGroup[] = useMemo(() => {
        return keyFiguresData.keyFiguresGroups.map(keyFiguresGroup => {
            return {
                ...keyFiguresGroup,
                keyFigures: keyFiguresGroup.keyFigures.map(keyFigure => {
                    return {
                        ...keyFigure,
                        isPopular: popularKeyFiguresGroup.keyFigures.some(popularKeyFigure => popularKeyFigure.id === keyFigure.id),
                    };
                }),
            };
        });
    }, [keyFiguresData.keyFiguresGroups, popularKeyFiguresGroup.keyFigures]);

    const popularTags: ITags = useMemo(
        () => ({
            basics: { ...tagsData.tags.basics, tags: tagsData.tags.basics.tags.filter(tag => tag.isPopular) },
            rewards: { ...tagsData.tags.rewards, tags: tagsData.tags.rewards.tags.filter(tag => tag.isPopular) },
            tradings: { ...tagsData.tags.tradings, tags: tagsData.tags.tradings.tags.filter(tag => tag.isPopular) },
            investmentHorizon: { ...tagsData.tags.investmentHorizon, tags: tagsData.tags.investmentHorizon.tags.filter(tag => tag.isPopular) },
            investmentRegion: { ...tagsData.tags.investmentHorizon, tags: tagsData.tags.investmentRegion.tags.filter(tag => tag.isPopular) },
            alphaBeta: { ...tagsData.tags.alphaBeta, tags: tagsData.tags.alphaBeta.tags.filter(tag => tag.isPopular) },
        }),
        [
            tagsData.tags.basics,
            tagsData.tags.investmentHorizon,
            tagsData.tags.investmentRegion.tags,
            tagsData.tags.rewards,
            tagsData.tags.tradings,
            tagsData.tags.alphaBeta,
        ]
    );

    return {
        popularKeyFiguresGroup,
        keyFiguresGroupsWithIsPopularIndication,
        popularTags,
    };
};
